module.exports = "/assets/delice-page/bottle_1@2x.jpg?MTiWG7C";